import { useEffect, useState } from 'react';

const localPaymentKey = 'paymentSysNoObj';

function formatTradeSysNoVal(sysNo) {
  if (sysNo) {
    return sysNo.toString().replace(/\D/g, '');
  } else {
    return;
  }
}

export default function useLocalPayment(supplierSysNo?: string) {
  const [localPaymentObj, setLocalPaymentObj] = useState<any>([]);
  const [localPaymentSysNo, setLocalPaymentSysNo] = useState();
  const [localTradeAgreementSysNo, setLocalTradeAgreementSysNo] = useState();

  useEffect(() => {
    const paymentSysNoObj = getPaymentLocalObj();
    setLocalPaymentObj(paymentSysNoObj);
    if (paymentSysNoObj?.length) {
      const paymentData = paymentSysNoObj.find((item) => item.supplierSysNo === supplierSysNo);
      setLocalPaymentSysNo(paymentData?.sysNo);
      setLocalTradeAgreementSysNo(paymentData?.tradeAgreementSysNo);
    }
  }, [supplierSysNo]);

  function getPaymentLocalObj() {
    let paymentSysNoObj = [];
    const localPayment = localStorage.getItem(localPaymentKey);
    if (localPayment) {
      paymentSysNoObj = JSON.parse(localPayment);
      if (paymentSysNoObj?.length) {
        // 过滤历史数据
        paymentSysNoObj = paymentSysNoObj.filter((item) => item?.sysNo !== -1);
      }
    }
    return paymentSysNoObj;
  }

  // 更新本地帐期信息
  function updateLocalPayment(sysNo: string, supplierSysNo: string) {
    if (!supplierSysNo) return;
    const paymentLocalObj = getPaymentLocalObj();
    let objList = [];
    if (!!paymentLocalObj?.length) {
      const paymentData = paymentLocalObj.find((item) => item.supplierSysNo === supplierSysNo);
      if (paymentData) {
        // 更新对应供应商帐期信息
        objList = paymentLocalObj.map((item) => {
          if (item.supplierSysNo === supplierSysNo) {
            item.sysNo = sysNo;
            item.supplierSysNo = supplierSysNo;
          }
          return item;
        });
      } else {
        objList = [...paymentLocalObj];
        // 追加帐期信息
        objList.push({
          sysNo: sysNo,
          supplierSysNo: supplierSysNo,
        });
      }
    } else {
      // 新增帐期信息
      objList.push({
        sysNo: sysNo,
        supplierSysNo: supplierSysNo,
      });
    }
    localStorage.setItem(localPaymentKey, JSON.stringify(objList));
  }

  // 更新本地协议信息
  function updateLocalTradeAgreement(tradeAgreementSysNo: string, supplierSysNo: string) {
    if (!supplierSysNo) return;
    const paymentLocalObj = getPaymentLocalObj();
    let objList = [];
    if (!!paymentLocalObj.length) {
      const index = paymentLocalObj.findIndex((item) => item.supplierSysNo === supplierSysNo);
      objList = [...paymentLocalObj];
      if (index === -1) {
        // 追加协议信息
        objList.push({
          supplierSysNo: supplierSysNo,
          tradeAgreementSysNo: tradeAgreementSysNo,
        });
      } else {
        // 更新协议信息
        objList[index].tradeAgreementSysNo = tradeAgreementSysNo;
      }
    } else {
      objList.push({
        supplierSysNo: supplierSysNo,
        tradeAgreementSysNo: tradeAgreementSysNo,
      });
    }

    localStorage.setItem(localPaymentKey, JSON.stringify(objList));
  }

  function getFrontDefaultTradeMethodList() {
    const paymentSysNoObj = getPaymentLocalObj();
    const frontDefaultTradeMethodList = [];
    if (paymentSysNoObj?.length) {
      paymentSysNoObj.forEach((item) => {
        if (item.sysNo) {
          var period = item.sysNo.toString().split('-');
          frontDefaultTradeMethodList.push({
            supplierSysNo: formatTradeSysNoVal(item.supplierSysNo),
            agreementSysNo: formatTradeSysNoVal(item.tradeAgreementSysNo),
            accountPeriod: formatTradeSysNoVal(period[0]),
            billingPeriod: formatTradeSysNoVal(period[1] ? period[1] : null),
          });
        }
      });
    }
    return frontDefaultTradeMethodList;
  }
  return {
    localPaymentObj,
    localPaymentSysNo,
    updateLocalPayment,
    localTradeAgreementSysNo,
    updateLocalTradeAgreement,
    getPaymentLocalObj,
    getFrontDefaultTradeMethodList,
  };
}
